<template>
  <div class="upload-wrap">
    <div
      v-if="(isFromWechat && userWXUpload) || isApp"
      @click.stop="nativeUploadImg"
    >
      <slot />
    </div>
    <template v-else>
      <div class="custom">
        <slot />
      </div>
      <input
        ref="uploadFile"
        class="upload"
        type="file"
        :multiple="multiple"
        :accept="config.validateOptions.typesCanBeSent.join(',')"
        @change="beforeQiniuUpload"
      />
    </template>
  </div>
</template>

<script>
import * as cyDetect from '@cy/detect';
import { uploadImage, uploadbase64ToQiniu } from '@/utils/wx';
import { doPoint } from '@/utils/index';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ChunyuUpload } from '@cy/chunyuUploadPlus';

let uploadMaxCount = 0;
const wx = require('weixin-js-sdk');

export default {
  name: 'UploadImg',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    // 是否使用微信小程序上传功能
    userWXUpload: {
      type: Boolean,
      default: true,
    },
    uploadConfig: {
      type: Object,
      default: () => {
        return { validateOptions: {} };
      },
    },
    origin: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      h5Loading: false, // h5上传的loading
      loading: false, // 上传loading
      config: {
        // 上传配置
        validateOptions: {
          miniCount: 1,
          maxCount: 2, // 上传数量
          miniSize: '0',
          maxSize: '10240', // 文件大小
          typesCanBeSent: [
            'image/gif',
            'image/png',
            'image/jpeg',
            'image/bmp',
            'image/webp',
          ], // 文件类型
        },
      },
      // 微信 chooseImage 接口配置
      wxUploadConfig: {
        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      },
    };
  },
  computed: {
    isFromWechat() {
      if (cyDetect.isFromWechat()) {
        return true;
      }
      return false;
    },
    isApp() {
      if (
        (cyDetect.isFromCY() && cyDetect.isGreaterAppVersion('9.4.0', true)) ||
        (cyDetect.isFromCYClinic() &&
          cyDetect.isGreaterAppVersion('5.6.8', true))
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    // 检测loading
    loading: {
      handler(val) {
        if (val) {
          this.$createToast({
            txt: '请稍等...',
            type: 'txt',
          }).show();
        }
      },
    },
  },
  mounted() {
    if (this.isApp) {
      window.photoUploadDone = imageInfo => {
        console.log(imageInfo);
        try {
          const content = [...JSON.parse(imageInfo.img_urls || '[]')];
          let list;
          console.log(list, 'applist');
          // 多张图片返回数组，单张图片直接返回src
          if (this.multiple) {
            list = this.value.concat(content);
          } else {
            list = [content];
          }
          this.$emit('input', list);
          this.$createToast({
            txt: '上传成功...',
            type: 'txt',
          }).show();
        } catch (error) {
          console.log(error);
        }
      };
    }
  },
  methods: {
    /**
     * @description 图片上传
     * @param {object} e 事件对象
     */
    beforeQiniuUpload(e) {
      const fileList = e.currentTarget.files;
      console.log(fileList);
      const uploadInstance = new ChunyuUpload(
        fileList,
        {
          validateOptions: {
            ...this.config.validateOptions,
            ...this.uploadConfig?.validateOptions,
          },
        },
        next => {
          console.log('next', next);
          this.$emit('update:visible', true);
        },
        error => {
          this.$emit('update:visible', false);
          console.log(error);
        },
        res => {
          this.$emit('update:visible', false);
          console.log('res', 'res执行啦');
          const list = this.value.slice(0);
          console.log(list, 'qiniu');
          let listResult;
          // 多张图片返回数组，单张图片直接返回src
          if (this.multiple) {
            list.push(res.img_url);
            listResult = list.splice(0, 9);
          } else {
            listResult = [res.img_url];
          }
          this.$emit('input', listResult);
        }
      );

      uploadInstance
        .validation()
        .then(res => {
          console.log('validation', res);
          uploadInstance.start();
        })
        .catch(res => {
          const { hasPassed, countCheck, sizeCheck } = res;
          console.log(res);
          if (!hasPassed) {
            this.$emit('update:visible', false);
            this.h5Loading = false;
            if (!countCheck.hasPassed) {
              this.$createToast({
                txt: `最多上传${this.uploadConfig?.validateOptions?.maxCount ||
                  this.config.validateOptions.maxCount}张`,
                type: 'txt',
              }).show();
            } else if (!sizeCheck.hasPassed) {
              this.$createToast({
                txt: `文件最大限制${Number(
                  this.config.validateOptions.maxSize
                ) / 1024}M`,
                type: 'txt',
              }).show();
            } else {
              this.$createToast({
                txt: '上传失败',
                type: 'txt',
              }).show();
            }
          }
        })
        .finally(() => {
          // 清除已选文件，避免无法连续上传同张图片
          this.$refs.uploadFile.value = '';
        });
    },
    /**
     * @description native上传
     */
    nativeUploadImg() {
      this.doPagePoint('AppClick', {
        activity_name: '海报传播活动',
        page_title: document.title,
        click_position: this.origin,
      });
      // 微信环境调用微信上传
      if (this.isFromWechat) {
        this.wxUploadImg();
        // 端上调用原生上传
      } else if (
        this.isApp &&
        window.ChunyuNativeBridge &&
        window.ChunyuNativeBridge.invoke
      ) {
        try {
          uploadMaxCount = this.uploadConfig?.validateOptions?.maxCount
            ? this.uploadConfig.validateOptions.maxCount - this.value.length
            : this.config.validateOptions.maxCount - this.value.length;
          window.ChunyuNativeBridge.invoke(
            '1.0',
            'chooseMultiImage',
            JSON.stringify({
              maxCount: uploadMaxCount,
              onUploadDone: 'photoUploadDone',
            })
          );
        } catch (e) {
          this.$createToast({
            txt: '你的app版本暂不支持上传，请下载最新版本',
            type: 'txt',
          }).show();
        }
      }
    },
    /**
     * @description 微信上传
     */
    wxUploadImg() {
      this.wxUploadConfig.count =
        this.config.validateOptions.maxCount - this.value.length;
      uploadImage(this.wxUploadConfig)
        .then((res = {}) => {
          const { localIds, token } = res;
          this.getLocalImgData(localIds, token);
        })
        .catch(error => {
          this.$createToast({
            txt: error.errMsg || '上传失败~',
            type: 'txt',
          }).show();
        });
    },

    /**
     * @description 微信获取本地图片接口，转base64
     * @param {Array} localIds // 图片的localID
     * @param {string} token 七牛token
     */
    getLocalImgData(localIds, token) {
      const self = this;
      const localId = localIds.pop();
      wx.getLocalImgData({
        localId,
        async success(res) {
          const { localData } = res;
          let imageBase64 = '';
          if (localData.indexOf('data:image') === 0) {
            // 苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
            imageBase64 = localData;
          } else {
            // 此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
            // 此时一个正常的base64图片路径就完美生成赋值到img的src中了
            imageBase64 = `data:image/jpeg;base64,${localData.replace(
              /\n/g,
              ''
            )}`;
          }

          if (self.value && self.value.length === 9) {
            self
              .$createToast({
                txt: '最多上传9张图片~',
                type: 'txt',
              })
              .show();
            return;
          }
          try {
            const res1 = await uploadbase64ToQiniu(imageBase64, token);
            let list = self.value.slice(0);
            console.log(list, 'weixinlist');
            // 多张图片返回数组，单张图片直接返回src
            if (this.multiple) {
              list.push(res1.img_url);
            } else {
              list = [res1.img_url];
            }
            self.$emit('input', list);
          } catch (error) {
            console.log(error);
            self
              .$createToast({
                txt: '上传失败~',
                type: 'txt',
              })
              .show();
          }

          // 递归上传
          if (localIds.length > 0) {
            self.getLocalImgData(localIds, token);
          }
        },
        fail(error) {
          console.log('getLocalImgData：失败', error);
        },
      });
    },
    /**
     * 打点函数
     *
     * @param type type
     * @param data 打点数据
     */
    doPagePoint(type, data) {
      let app;
      if (cyDetect.isFromCY()) {
        app = '0';
      } else if (cyDetect.isFromCYClinic()) {
        app = '1';
        // eslint-disable-next-line no-underscore-dangle
      } else if (window.__wxjs_environment === 'miniprogram') {
        app = 'weixin_mini';
      }
      return doPoint(type, {
        app,
        ...data,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-wrap {
  position: absolute;
  // top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  .custom {
    width: 100%;
    height: 100%;
  }
  .upload {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}
</style>
